import React from 'react';
import PillarPageLayout from '../components/PillarPageLayout';

const ExtendPage: React.FC = () => {
  const diagram = (
    <>
      <p className="font-semibold text-slate-700 mb-5 text-center text-sm">Without Megadish</p>
      <div className="flex items-center justify-center gap-3 my-3 flex-wrap">
        <div className="px-4 py-2.5 rounded-lg text-sm font-medium bg-white text-slate-700 border border-slate-300">
          Your phone
        </div>
        <div className="px-3 text-center">
          <div className="text-2xl">📵</div>
          <div className="text-xs text-slate-400">No signal</div>
        </div>
        <div className="px-4 py-2.5 rounded-lg text-sm font-medium bg-blue-100 text-blue-700 border border-blue-200 text-center">
          Hotel WiFi<br />
          <span className="text-xs">200m away</span>
        </div>
      </div>
      <p className="text-xs text-slate-500 text-center italic mt-2">
        Your phone's antenna can't reach distant WiFi
      </p>

      <hr className="border-t border-dashed border-slate-300 my-7" />

      <p className="font-semibold text-slate-700 mb-5 text-center text-sm">With Megadish Dish</p>
      <div className="flex items-center justify-center gap-3 my-3 flex-wrap">
        <div className="px-4 py-2.5 rounded-lg text-sm font-medium bg-white text-slate-700 border border-slate-300">
          Your phone
        </div>
        <span className="text-slate-400">→</span>
        <div className="px-4 py-2.5 rounded-lg text-sm font-medium bg-green-600 text-white text-center">
          📡<br />Megadish
        </div>
        <span className="text-purple-600 font-bold">━━→</span>
        <div className="px-4 py-2.5 rounded-lg text-sm font-medium bg-blue-100 text-blue-700 border border-blue-200 text-center">
          Hotel WiFi<br />
          <span className="text-xs">200m away</span>
        </div>
      </div>
      <p className="text-xs text-slate-500 text-center italic mt-2">
        Dish antenna reaches further, creates local network for your devices
      </p>
    </>
  );

  const explanation = (
    <>
      <h3 className="text-xl font-semibold text-slate-800 mb-4">Why range matters</h3>
      <p className="text-slate-600 mb-4 leading-relaxed">
        Your phone and laptop have tiny antennas designed for nearby WiFi. 
        When the hotel WiFi doesn't reach the pool, or the campsite signal 
        fades at your pitch, you're stuck.
      </p>
      <p className="text-slate-600 leading-relaxed">
        The Megadish dish version uses directional antenna technology to reach 
        WiFi sources that are much further away. Point it towards the source, 
        and it pulls in signals your devices can't see — then creates a local 
        network you can connect to from right next to it.
      </p>
    </>
  );

  const productNote = (
    <>
      <span className="text-xl">ℹ️</span>
      <span>
        <strong>Dish version only.</strong> The compact Megadish doesn't extend range — 
        it's designed for situations where you're close to the WiFi but want the other benefits.
      </span>
    </>
  );

  return (
    <PillarPageLayout
      icon="📡"
      title="Extend"
      subtitle="Reach WiFi your devices can't"
      color="purple"
      diagram={diagram}
      explanation={explanation}
      benefits={[
        'Dish antenna focuses reception in one direction',
        'Reaches hotel WiFi from the beach or pool',
        'Connects from your pitch to the campsite office',
        'Picks up shore WiFi from your boat',
        'Works over open ground and water',
      ]}
      scenarios={[
        { emoji: '🏖️', label: 'Beach from hotel' },
        { emoji: '🏕️', label: 'Pitch from campsite office' },
        { emoji: '⛵', label: 'Boats & marinas' },
        { emoji: '🚐', label: 'Motorhomes' },
      ]}
      productNote={productNote}
    />
  );
};

export default ExtendPage;
